exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-4cf97420!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Selo.vue
// module id = 43
// module chunks = 0